import React from "react";
import { Field, reduxForm, InjectedFormProps } from "redux-form";
import { TextField, Button } from "capitalrx-components";

interface DefaultProps {
  path: string;
  sectionTitle: string;
  buttonText: string;
  handleClick: Function;
}

type Props = InjectedFormProps & DefaultProps;

const PharmacySummaryForm: React.FC<DefaultProps & InjectedFormProps<{}, DefaultProps>> = (props: Props) => {
  const { buttonText, sectionTitle, path, handleClick } = props;

  return (
    <div className="test-claim-section-summary">
      <div className="row caprx-h-center-text">
        <div className="col">
          <div className="test-claim-section-description mb30">{sectionTitle}</div>
          <Button
            handleClick={(): void => handleClick()}
            data-testid="test__add_pharmacy"
            extraClasses="test-claim-button mb30"
            buttonType="router-link"
            buttonStyle="outline"
            color="darkblue"
            path={path}
          >
            <span className="caprx-icon-input-plus mr5" />
            {buttonText}
          </Button>
        </div>
      </div>
      <div className="row">
        <div className="col">
          <Field
            component={TextField}
            id="pharmacy-npi"
            data-testid="test__pharmacy-npi"
            name="pharmacy.details.npi"
            label="Service Provider ID"
            type="text"
            readOnly={true}
          />
        </div>

        <div className="col">
          <Field
            component={TextField}
            id="pharmacy-name"
            data-testid="test__pharmacy-name"
            name="pharmacy.details.name"
            label="Provider Name"
            type="text"
            readOnly={true}
          />
        </div>
      </div>
      <div className="row">
        <div className="col">
          <Field
            component={TextField}
            id="pharmacy-address-line-1"
            data-testid="test__pharmacy-address-line-1"
            name="pharmacy.details.address_line_1"
            label="Address Line 1"
            type="text"
            readOnly={true}
          />
        </div>

        <div className="col">
          <Field
            component={TextField}
            id="pharmacy-address-line-2"
            data-testid="test__pharmacy-address-line-2"
            name="pharmacy.details.address_line_2"
            label="Address Line 2"
            type="text"
            readOnly={true}
          />
        </div>
      </div>
      <div className="row">
        <div className="col">
          <Field
            component={TextField}
            id="pharmacy-city"
            data-testid="test__pharmacy-city"
            name="pharmacy.details.city"
            label="City"
            type="text"
            readOnly={true}
          />
        </div>
        <div className="col">
          <Field
            component={TextField}
            id="pharmacy-state"
            data-testid="test__pharmacy-state"
            name="pharmacy.details.state"
            label="State"
            type="text"
            readOnly={true}
          />
        </div>
        <div className="col">
          <Field
            component={TextField}
            id="pharmacy-zip"
            data-testid="test__pharmacy-zip"
            name="pharmacy.details.zip"
            label="Zip Code"
            type="text"
            readOnly={true}
          />
        </div>
        <div className="col">
          <Field
            component={TextField}
            id="pharmacy-phone"
            data-testid="test__pharmacy-phone"
            name="pharmacy.details.phone"
            label="Phone Number"
            type="text"
            readOnly={true}
          />
        </div>
      </div>
    </div>
  );
};

export default reduxForm<{}, DefaultProps>({ form: "TestClaim" })(PharmacySummaryForm);
